import { Box } from '@material-ui/core';
import { Text } from 'component/customize_style_component/styled_title';
import themes from 'styles/themes';
import { ReactComponent as BtnDislike } from 'assets/svg/dislike_old.svg';
import { ReactComponent as DislikeFill } from 'assets/svg/disliked_old.svg';
import { ReactComponent as BtnLikeFill } from 'assets/svg/like_fill_v2.svg';
import { ReactComponent as BtnLike } from 'assets/svg/like_v2.svg';
import { EValueAnswers } from '../style_quiz/style_quiz';
import { useStyles } from './style';
import { useState } from 'react';
import { Spinner } from 'react-bootstrap';

export default function ColorItem({
    handleLike,
    handlDislike,
    listColor,
    title,
    reaction,
    loadingAnswer,
    swiperInstance,
    index,
    loadingQuiz,
}) {
    const classes = useStyles();
    const [isLoadingStyleType, setIsLoadingStyleType] = useState<EValueAnswers>(EValueAnswers.DISLIKE);
    const isQuestionDataLoaded = Boolean(!loadingQuiz && listColor.length);
    const renderReactionPanel = () => {
        return (
            <div className={classes.action}>
                {isLoadingStyleType === EValueAnswers.DISLIKE && index === swiperInstance.realIndex && loadingAnswer ? (
                    <span className={classes.spinner}>
                        <Spinner
                            animation="border"
                            style={{ width: 30, height: 30, color: themes.palette.primary.main }}
                        />
                    </span>
                ) : reaction === EValueAnswers.DISLIKE ? (
                    <span className={classes.actionsIcon}>
                        <DislikeFill
                            style={{
                                width: 32,
                                height: 32,
                                color: themes.palette.common.white,
                                fill: themes.palette.primary.main,
                            }}
                        />
                    </span>
                ) : (
                    <span
                        className={classes.actionsIcon}
                        onClick={() => {
                            if (isQuestionDataLoaded) {
                                handlDislike();
                                setIsLoadingStyleType(EValueAnswers.DISLIKE);
                            }
                        }}
                    >
                        <BtnDislike
                            width={32}
                            height={32}
                            style={{
                                width: 32,
                                height: 32,
                                color: themes.palette.primary.main,
                                fill: themes.palette.primary.main,
                            }}
                        />
                    </span>
                )}
                {isLoadingStyleType === EValueAnswers.LIKE && index === swiperInstance.realIndex && loadingAnswer ? (
                    <span className={classes.spinner}>
                        <Spinner
                            animation="border"
                            style={{ width: 30, height: 30, color: themes.palette.primary.main }}
                        />
                    </span>
                ) : reaction === EValueAnswers.LIKE ? (
                    <span className={classes.actionsIcon}>
                        <BtnLikeFill style={{ width: 32, height: 32, color: '#E4454F' }} />
                    </span>
                ) : (
                    <span
                        className={classes.actionsIcon}
                        onClick={() => {
                            if (isQuestionDataLoaded) {
                                handleLike();
                                setIsLoadingStyleType(EValueAnswers.LIKE);
                            }
                        }}
                    >
                        <BtnLike style={{ width: 32, height: 32, color: themes.palette.primary.main }} />
                    </span>
                )}
            </div>
        );
    };

    return (
        <Box className={classes.sizesWrapper}>
            <Box
                textAlign={'center'}
                width="100%"
                margin="8px 0 10px"
                display="flex"
                alignItems={'center'}
                justifyContent="space-around"
                flexDirection={'column'}
            >
                <Text size={19}>{title}</Text>
            </Box>
            <Box className={classes.boxSizes}>
                <Box height={'100%'} marginTop="auto" marginBottom={'auto'} display="flex" flexWrap="wrap">
                    {loadingQuiz && !listColor.length ? (
                        <Box
                            width={'100%'}
                            height={'100%'}
                            display={'flex'}
                            alignItems={'center'}
                            justifyContent={'center'}
                            flexDirection={'column'}
                        >
                            <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                        </Box>
                    ) : listColor.length ? (
                        listColor.map((item, i) => {
                            return (
                                <Box
                                    key={i}
                                    className={classes.boxItem}
                                    display="flex"
                                    alignItems={'center'}
                                    justifyContent="center"
                                >
                                    <Box
                                        className={classes.boxItemColorPanel}
                                        style={{ background: `${item}` }}
                                        borderRadius={'50%'}
                                    ></Box>
                                </Box>
                            );
                        })
                    ) : (
                        <></>
                    )}
                </Box>
            </Box>
            {renderReactionPanel()}
        </Box>
    );
}
